var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-block",domProps:{"innerHTML":_vm._s(require(`!!html-loader!icons/icon-${this.icon}.svg`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }